import { StatusModalBloquearDesbloquearEntrada } from 'constants/constantesBloquearDesbloquearEntradaUsuario';
import { useAuth } from 'context/AuthContext';
import { useState, useEffect } from 'react';
import UsuariosService from 'services/UsuariosService';

const useBloquearDesbloquearEntrada = ({ contaEstaAtiva, nomeUsuario, onCloseModal, userId }) => {

    // Estados
    const [mensagem, setMensagem] = useState('');
    const { direito, tenant, tenants } = useAuth();
    const [modalControl, setModalControl] = useState(StatusModalBloquearDesbloquearEntrada.CONFIRMACAO);

    useEffect(() => {
        setMensagem('');
        setModalControl(StatusModalBloquearDesbloquearEntrada.CONFIRMACAO);
    }, [contaEstaAtiva, nomeUsuario]);

    // Constantes
    const obterTituloModalConfirmacao = () => contaEstaAtiva ? 'Confirmar Bloqueio Entrada' : 'Confirmar Desbloqueio Entrada';

    const obterDescricaoModalConfirmacao = () => {
        if (contaEstaAtiva) {
            return (
                <>
                    <p>
                        Você está prestes a bloquear o usuário {nomeUsuario}. Essa ação impede imediatamente novos logins e, caso a conta já esteja conectada, a sessão será encerrada em até 60 minutos em todos os serviços da Microsoft. O bloqueio é recomendado em situações em que há suspeita de que a senha ou o nome de usuário tenham sido comprometidos.
                    </p>
                    <p>A operação é reversível, não remove dados do usuário e não interrompe o recebimento de e-mails. Assinaturas e cobranças permanecem ativas.</p>
                </>
            )
        } else {
            return (
                <p>O usuário {nomeUsuario} poderá acessar novamente o Microsoft 365 e utilizar os serviços normalmente.</p>
            )
        }
    }

    const obterLabelBotaoAcaoModalConfirmacao = () => contaEstaAtiva ? 'Bloquear Usuário' : 'Desbloquear Usuário';

    const acao = contaEstaAtiva ? 'Bloquear' : 'Desbloquear';

    // Funções de Ação
    const executarAcao = async () => {
        setModalControl(StatusModalBloquearDesbloquearEntrada.CARREGANDO);
        try {
            await UsuariosService.AlterarEstadoDoUsuarioNoTenant(construirBodyRequisicaoAlterarEstadoDoUsuarioNoTenant(!contaEstaAtiva));
            if (contaEstaAtiva)
                setMensagem(`Usuário ${nomeUsuario} foi bloqueado com sucesso.`);
            else
                setMensagem(`Usuário ${nomeUsuario} desbloqueado com sucesso. A liberação pode levar até 15 minutos para permitir o acesso novamente ao Microsoft 365.`);

            setModalControl(StatusModalBloquearDesbloquearEntrada.SUCESSO)
        } catch (e) {
            setMensagem(`Erro ao tentar ${acao.toLocaleLowerCase()} o usuário ${nomeUsuario}.`);
            setModalControl(StatusModalBloquearDesbloquearEntrada.ERRO)
        }
    };

    const executarTentarNovamente = async () => {
        setModalControl(StatusModalBloquearDesbloquearEntrada.CONFIRMACAO);
    };

    const definirComportamentoAoFecharModal = () => {
        let deveRecarregarUsuarios = modalControl === StatusModalBloquearDesbloquearEntrada.SUCESSO;
        onCloseModal(deveRecarregarUsuarios);
    }

    const construirBodyRequisicaoAlterarEstadoDoUsuarioNoTenant = (ativarConta) => {
        const direitoId = direito.entitlementId;
        const tenantCode = tenant.tenantCode;
        const tenantEncontrado = tenants.find(t => t.tenantCode?.toLowerCase() === tenantCode?.toLowerCase());

        if (!tenantEncontrado) {
            throw new Error('Tenant não encontrado para o código fornecido');
        }
        const tenantId = tenantEncontrado.axtTenantId;
        return {
            tenantId,
            usuarioId: userId,
            direitoId,
            tenantCode,
            ativarConta
        };
    };

    return ({
        userId,
        mensagem,
        modalControl,
        contaEstaAtiva,

        tituloModalConfirmacao: obterTituloModalConfirmacao(),
        descricaoModalConfirmacao: obterDescricaoModalConfirmacao(),
        labelBotaoAcaoModalConfirmacao: obterLabelBotaoAcaoModalConfirmacao(),

        executarAcao,
        executarTentarNovamente,
        definirComportamentoAoFecharModal,
    })
}

export default useBloquearDesbloquearEntrada